import { EmployeeInfo } from '@/redux/modules/EmployeeInfo';
import { server } from '../core/server/axios';
import { BACKEND_URL } from '@/core/config';
import { EmployeeAttachment } from '@/constatns';
import { Employee } from '@/pages/Employees/EmployeesList';

/** Компактный DTO подбора комиссии: без ИИН, адресов и документов */
export interface CommissionCandidate {
    id: number;
    fullName: string;
    position: string | number;
    positionName?: string;
    status?: number;
    statusName?: string;
}

export class EmployeeController {

    async getEmployeeList(): Promise<{ count: number, employees: Employee[] }> {
        return await server.get('/Employee', {
            baseURL: BACKEND_URL
        });
    }

    async getEmployee(id: string) {
        return await server.get(`/Employee/${id}`, {
            baseURL: BACKEND_URL
        });
    }

    async updateEmployee(request: any) {
        return await server.post(`/Employee/${request?.id}`, {
            ...request
        }, {
            baseURL: BACKEND_URL
        });
    }

    async addDocument(employeeId: number | string, document: any) {
        return await server.post(`/Employee/${employeeId}/identity-documents`, {
            ...document
        }, {
            baseURL: BACKEND_URL
        });
    }

    async addAddress(employeeId: number | string, address: any) {
        return await server.post(`/Employee/${employeeId}/address`, {
            ...address
        }, {
            baseURL: BACKEND_URL
        });
    }

    async addEmployee(employeeInfo: EmployeeInfo) {
        return await server.post('/Employee', {
            login: employeeInfo?.login,
            iin: employeeInfo?.iin,
            fullName: (employeeInfo?.lastName + " " + employeeInfo?.firstName + " " + employeeInfo?.middleName).trim(),
            firstName: employeeInfo?.firstName,
            lastName: employeeInfo?.lastName,
            middleName: employeeInfo?.middleName,
            birthDate: employeeInfo?.birthday,
            phone: employeeInfo?.phone,
            positionCode: employeeInfo?.position?.code,
            bankName: employeeInfo?.bankName,
            iban: employeeInfo?.iban,
            bik: employeeInfo?.bik,
            bin: employeeInfo?.bankBin,
            isResident: employeeInfo?.isResident,
            workType: employeeInfo?.workType,
            depIds: employeeInfo?.depsId,
            regAddress: {
                country: employeeInfo?.country,
                countryCode: employeeInfo?.countryCode,
                region: employeeInfo?.region,
                postIndex: employeeInfo?.postIndex,
                locality: employeeInfo?.locality,
                street: employeeInfo?.street,
                number: employeeInfo?.number,
                flat: employeeInfo?.flat
            },
            factAddress: {
                country: employeeInfo?.factCountry,
                countryCode: employeeInfo?.factCountryCode,
                region: employeeInfo?.factRegion,
                postIndex: employeeInfo?.factPostIndex,
                locality: employeeInfo?.factLocality,
                street: employeeInfo?.factStreet,
                number: employeeInfo?.factNumber,
                flat: employeeInfo?.factFlat
            },
            identityDocuments: [
                {
                    docType: employeeInfo?.doctype,
                    docNumber: employeeInfo?.docNumber,
                    series: employeeInfo?.series,
                    issuePlace: employeeInfo?.issuePlace,
                    issueDate: employeeInfo?.issueDate,
                    validDate: employeeInfo?.validDate
                }
            ]
        }, {
            baseURL: BACKEND_URL
        });
    }

    async loadDocument(employeeId: string, file: File, documentType: EmployeeAttachment, depId: string | number) {
        console.log("documentType", documentType)
        const formData = new FormData();
        formData.append("File", file);
        formData.append("DocumentType", `${documentType}`);
        formData.append("DocumentNumber", "");
        formData.append("IssueDate", "");
        formData.append("ExpiryDate", "");
        formData.append("IssuedBy", "");
        formData.append("depId", `${depId}`);

        return await server.post(`/Employee/${employeeId}/documents`,
            formData, {
            Headers: {
                "Content-Type": "multipart/form-data",
                accept: "*/*",
            },
            baseURL: BACKEND_URL
        });
    }

    async getEmployeeDocuments(employeeId: string) {
        return await server.get(`/Employee/${employeeId}/documents`, {
            baseURL: BACKEND_URL
        });
    }

    async deleteDocuments(documentId: number) {
        return await server.delete(`/Employee/documents/${documentId}`, {
            baseURL: BACKEND_URL
        });
    }

    async getEmployeeDocument(docId: number) {
        return await server.get(`/Employee/documents/${docId}`, {
            responseType: "blob",
            baseURL: BACKEND_URL
        });
    }

    async getEmployeeByLogin(login: string): Promise<Employee> {
        return await server.get(`/Employee/login/${encodeURIComponent(login)}`, {
            baseURL: BACKEND_URL
        });
    }

    async breakStart() {
        return await server.get(`/Employee/breakStart`, {
            baseURL: BACKEND_URL
        });
    }

    async breakStop() {
        return await server.get(`/Employee/breakStop`, {
            baseURL: BACKEND_URL
        });
    }

    /**
     * Кандидаты в комиссию ревизии. Отбор по должностям идёт тем же списком, что и валидация
     * при сохранении комиссии, — свой фильтр на фронте держать не нужно.
     * Без status возвращаются только действующие; depId оставляет сотрудников точки и тех,
     * кто отвечает за сеть.
     */
    async getCommissionCandidates(depId?: number | null, status?: number): Promise<CommissionCandidate[]> {
        const res = await server.get('/employee/commission', {
            baseURL: BACKEND_URL,
            params: {
                depId: depId ?? undefined,
                status: status ?? undefined,
            },
        });

        // Ручка может отдавать как голый массив, так и обёртку со счётчиком — принимаем оба вида
        if (Array.isArray(res)) {
            return res;
        }

        return res?.items || res?.employees || res?.data || [];
    }
}